import React from "react";
import { Paper, Grid, Button } from "@material-ui/core";
import { DateInput } from "../../components/common/DateInput";
import { ProductSelect } from "../../components/listing/ProductSelect";
import { LocalizationContext } from "../../../core/localization/Localization";
import { isValidDate } from "../../../core/util/functions";
import { OrderIndFilter } from "../../../data/trading/orderIndicative/types";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { useAuth } from "../../../data/auth/hooks";
import { UserSelect } from "../../components/listing/UserSelect";
import { OrderIndStatus } from "../../components/common/OrderIndStatus";
import { StringInput } from "../../components/common/StringInput";
import { OrderSideSelect } from "../orders/OrderSideSelect";
import { EmployeeSelect } from "../../components/listing/EmployeeSelect";
import { NumberInput } from "../../components/common/NumberInput";

export interface OrderIndFilterEditorProps {
	filter?: OrderIndFilter;
	editFilter: (prop: keyof OrderIndFilter, value: any) => void;
	save: () => void;
	reset: () => void;
}

export const OrderIndFilterEditor: React.FunctionComponent<OrderIndFilterEditorProps> = ({
	filter,
	editFilter,
	save,
	reset,
}) => {
	const { getString } = React.useContext(LocalizationContext);
	const showWithDrawer = React.useContext(DisplayDrawerContext);

	const filterValue: OrderIndFilter = filter || {};

	const [auth] = useAuth();

	if (auth.status !== "successful") {
		return null;
	}

	return (
		<Paper
			style={{
				paddingLeft: "70px",
				paddingRight: "70px",
				paddingTop: "15px",
				paddingBottom: "15px",
			}}
		>
			<Grid container direction="column" spacing={6}>
				<Grid item container direction="row" spacing={2}>
					<Grid item xs={12} sm={6}>
						<OrderSideSelect
							handleChange={e => editFilter("side", e.target.value)}
							side={filter?.side}
							nullable
						/>
					</Grid>
				</Grid>
				<Grid item container direction="row" spacing={2}>
					<Grid item xs={12}>
						<ProductSelect
							label={getString("orderProduct")}
							predicate={prod => prod.prodId === filter?.product?.prodId}
							onChangeItem={prod => {
								editFilter("product", prod);
							}}
						/>
					</Grid>
				</Grid>
				

				<Grid item container direction="row" spacing={2}>
					<Grid item xs={12} sm={6}>
						<NumberInput<OrderIndFilter>
							item={filterValue}
							property="qtyfrom"
							onChange={e => editFilter("qtyfrom", e.target.value)}
							label={getString("orderQtyFrom")}
							decimalCount={0}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<NumberInput
							item={filterValue}
							property="qtyto"
							onChange={e => editFilter("qtyto", e.target.value)}
							label={getString("orderQtyTo")}
							decimalCount={0}
						/>
					</Grid>
				</Grid>

				<Grid item container direction="row" spacing={2}>
					<Grid item xs={12} sm={6}>
						<DateInput
							label={getString("filterFrom")}
							value={filter?.datefrom || null}
							onChange={date =>
								editFilter("datefrom", isValidDate(date) ? date.toISOString() : undefined)
							}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<DateInput
							label={getString("filterTo")}
							value={filter?.dateto || null}
							onChange={date =>
								editFilter("dateto", isValidDate(date) ? date.toISOString() : undefined)
							}
						/>
					</Grid>
				</Grid>


				<Grid item container direction="row" spacing={2}>
					<Grid item xs={12}>
						<EmployeeSelect
							label={getString("orderbrokName")}
							predicate={employee => employee.empId === filter?.brokerid}
							onChangeItem={employee => {
								editFilter("brokerid", employee);
							}}
						/>

						{/*						<UserSelect
							label={getString("orderbrokName")}
							predicate={user => user.userId === filter?.brokerid}
							onChangeItem={(user) => { editFilter("brokerid", user ? user.userId : undefined); }}
						/> */}
					</Grid>
				</Grid>

				<Grid item container direction="row" spacing={2}>
					<Grid item xs={12}>
						<OrderIndStatus
							label={getString("cliStatus")}
							predicate={status => status.ftValue === filter?.status}
							onChangeItem={status => {
								editFilter("status", status?.ftValue);
							}}
						/>
					</Grid>
				</Grid>

				<Grid item container direction="row-reverse" spacing={2}>
					<Grid item>
						<Button
							variant="contained"
							color="secondary"
							onClick={() => {
								save();
								showWithDrawer(undefined);
							}}
						>
							{getString("orderFilterConfirm")}
						</Button>
					</Grid>
					<Grid item>
						<Button variant="text" onClick={reset}>
							{getString("filterReset")}
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Paper >
	);
};
